<script lang="ts">
import Vue, { CreateElement, VNode } from 'vue';

export default Vue.extend({
  name: 'TemporaryPasswordDialog',

  functional: true,

  render (h: CreateElement, { parent }): VNode {
    return h('v-dialog', {
      props: {
        value: true,
        persistent: true,
        maxWidth: 500,
      },
    }, [
      h('v-card', [
        h('v-card-title', { class: 'headline' }, 'Password Change Required'),
        h('v-card-text', [
          h('p', { class: 'mb-4' }, 'You are currently using a temporary password. For security reasons, you must change your password before continuing.'),
          h('p', { class: 'mb-0' }, 'Click the button below to go to the security settings page where you can update your password.'),
        ]),
        h('v-card-actions', [
          h('v-spacer'),
          h('v-btn', {
            props: {
              to: parent.getAccountRoute({ name: 'user-security' }),
              color: 'primary',
            },
          }, 'Change Password'),
        ]),
      ]),
    ]);
  },
});
</script>
